import { Outlet } from "react-router-dom";
import { AudioPlayerProvider, useAudioPlayer } from "./AudioPlayerContext";
import { BottomPlayer } from "./BottomPlayer";

// .audio-lectures-root is rendered here, so its stylesheet belongs here too.
// It used to be imported only by AudioLectures, so opening a lecture directly
// (lazy route, list chunk never loaded) left the wrapper with no padding and
// the back button hidden under the fixed header.
import "./audiolectures.css";

// ─── Inner layout (needs context) ────────────────────────────────────────────
function AudioLayoutInner() {
  const { activeLecture, closePlayer } = useAudioPlayer();

  return (
    <div className={`audio-lectures-root ${activeLecture ? "has-player" : ""}`}>
      {/* This is where AudioLectures or LectureDetail will render */}
      <Outlet />

      {/* Persistent bottom player — always visible when a lecture is active */}
      {activeLecture && (
        <BottomPlayer lecture={activeLecture} onClose={closePlayer} />
      )}
    </div>
  );
}

// ─── Outer wrapper (provides context) ────────────────────────────────────────
export default function AudioLayout() {
  return (
    <AudioPlayerProvider>
      <AudioLayoutInner />
    </AudioPlayerProvider>
  );
}
